import type { SVGProps } from "react";

export default function MouseArrowIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M13.8122 16.1763L10.5302 12.8944L9.52799 13.8967C8.50199 14.9227 7.98896 15.4357 7.43757 15.3146C6.88618 15.1934 6.63537 14.5127 6.13374 13.1511L4.46074 8.61018C3.46005 5.89398 2.95971 4.5359 3.65967 3.83594C4.35963 3.13598 5.71771 3.63632 8.43391 4.63702L12.9748 6.31001C14.3364 6.81164 15.0172 7.06245 15.1383 7.61384C15.2594 8.16523 14.7464 8.67826 13.7204 9.70426L12.7182 10.7065L16.0001 13.9884C16.3399 14.3282 16.5098 14.4981 16.5883 14.6877C16.693 14.9404 16.693 15.2243 16.5883 15.4771C16.5098 15.6666 16.3399 15.8365 16.0001 16.1763C15.6602 16.5162 15.4903 16.6861 15.3008 16.7646C15.0481 16.8693 14.7642 16.8693 14.5114 16.7646C14.3218 16.6861 14.1519 16.5162 13.8122 16.1763Z"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
